
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import quoteCountHandler from "@WhiteCap/Handlers/QuoteCart/QuoteCartHandler";
import * as React from "react";
import { css } from "styled-components";
import { connect, ResolveThunks } from "react-redux";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import useQuoteCartProduct from "@WhiteCap/Hooks/useQuoteCartProduct";
import Typography from "@insite/mobius/Typography";
import Link from "@insite/mobius/Link";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";


type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory & WidgetProps;


const mapStateToProps = (state: CustomApplicationState) => ({
	quoteCount: state.WhiteCap?.quoteCart?.quoteCount,
});


const mapDispatchToProps = {
	quoteCountHandler
};

export interface QouteWrapperStyles {
	quoteWrapper?: InjectableCss;
	quoteSection?: InjectableCss;
	backBtnWrapper?: InjectableCss;
	emptyCart?: InjectableCss;
}

export const qouteWrapperStyles: QouteWrapperStyles = {
	quoteWrapper: {
		css: css`
			display: flex;
			${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
							flex-direction: column-reverse;
					`,
						css`
							flex-direction: column-reverse;
					`,
						null,
					],
					"max",
				)}
			.quote-sec{
				&:first-child{
					margin-right: 2%;
					${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
							margin: 20px 0 20px 0;
						`,
						css`
							margin: 20px 0 20px 0;
						`,
						null,
					],
					"max",
				)}
				}
			}
		`
	},
	quoteSection: {
		css: css`
			width: 49%;
			${({ theme }: { theme: BaseTheme }) =>
				breakpointMediaQueries(
					theme,
					[
						css`
							width: 100%;
					`,
						css`
							width: 100%;
					`,
						null,
					],
					"max",
				)}
		`
	},
	backBtnWrapper: {
		css: css`
			margin-bottom: 20px;
			button{
				min-width: 83px;
				max-width: 83px;
				&:hover{
					border-color: ${WhitecapColors.secondaryBtnBorder} !important;
					outline: none !important;
					border: 2px solid ${WhitecapColors.secondaryBtnBorder} !important;
					border-color: ${WhitecapColors.secondaryBtnBorder} !important;
				}
			}
		`
	},
	emptyCart: {
		css: css`
			p{
				color: ${WhitecapColors.lightBlack};
				font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
				font-style: normal;
				font-weight: 400;
				line-height: 1.42857143;
				font-size: 15px;
				margin-bottom: 10px;
				span{
					color: ${WhitecapColors.orangeLink}!important;
				}
			}
		`
	}
};

const styles = qouteWrapperStyles;


const BrcikQuoteWrapper: React.FC<Props> = ({ id, quoteCount, quoteCountHandler }: Props) => {
	const backToPreviousPage = () => {
		history.back();
	}

	const { cart } = useQuoteCartProduct();

	React.useEffect(() => {
		if (cart) {
			quoteCountHandler({ quoteCount: cart.quoteCount })
		}
	}, [cart]);

	if (quoteCount === 0) {
		return (
			<StyledWrapper className="empty-cart" {...styles.emptyCart}>
				<Typography as="p">{translate("You have no items in your quote cart.")}</Typography>
				<Typography as="p">{translate("Click ")}
					<Link href="/Catalog/brick-selector">here</Link> {translate("to continue shopping.")}
				</Typography>
			</StyledWrapper>
		);
	}

	return (
		<>
			<StyledWrapper {...styles.backBtnWrapper}>
				<Button onClick={backToPreviousPage} variant="secondary">{translate("Back")}</Button>
			</StyledWrapper>
			<StyledWrapper {...styles.quoteWrapper}>
				<StyledWrapper className="quote-sec" {...styles.quoteSection}>
					<Zone contentId={id} zoneName={"BrickQuoteCard"} />
				</StyledWrapper>
				<StyledWrapper className="quote-sec"  {...styles.quoteSection}>
					<Zone contentId={id} zoneName={"BrickQuoteForm"} />
				</StyledWrapper>
			</StyledWrapper>
		</>
	);
};

const definition: WidgetDefinition = {
	displayName: "Brick Wrapper",
	group: "Common",
};

const widgetModule: WidgetModule = {
	component: connect(mapStateToProps, mapDispatchToProps)(withHistory(BrcikQuoteWrapper)),
	definition,
};

export default widgetModule;
